module.exports = __webpack_public_path__ + "assets/img/propertymanagement.e4ea0a21.svg";